// Filters
import ClassNames from 'classnames';
import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import { closeUI, EndTheChat } from '../redux/actions/chatInitAction';
import { notification } from '../redux/actions/alertAction';
import { getTranslator } from '../locales';
import {
  toggleSound,
  toggleEnterKey,
  setThreadsOrering
} from '../redux/actions/settingsAction';
import {
  select as selectFilter,
  toggleVisibility as toggleFiltersVisibility
} from '../redux/actions/filtersAction';

@connect((Store) => {
  const t = getTranslator();

  return {
    labels: {
      F_ALL_DISCUSSIONS: t.t('All Discussions'),
      F_BY_TOPIC: t.t('Filter by Topic'),
      F_FOLLOWED: t.t('Followed', { count: Store.luser.followedThreadIds.length }),
      F_SEARCH: t.t('Search…'),
      F_UNANSWERED: t.t('Unanswered'),
      F_UNREAD: t.t(
        'Unread',
        { count: _.filter(Store.threads.list, thread => (thread.read !== true)).length }
      ),
      F_YOUR_QUESTIONS: t.t('Your questions'),
      LIVE_CHAT: t.t('Live Chat'),
      OFF: t.t('Off'),
      ON: t.t('On'),
      SETTINGS: t.t('Settings'),
      S_PRESS_ENTER_TO_SUBMIT: t.t('Press \"Enter\" to send'),
      S_SOUND: t.t('Sound notifications'),
      S_THREAD_ORDERING: t.t('Order by activity'),
      ACTION_LEAVE_CHAT: t.t('Leave the Chat'),
      ARE_YOU_SURE_LEAVE: t.t('Are you sure you want to leave the chat?'),
      CHAT_HAS_BEEN_CLOSED: t.t('The chat has been closed'),
    },
    luser: Store.luser,
    mobilePanels: Store.chat.mobilePanels,
    threads: Store.threads.list,
    followedThreadIds: Store.luser.followedThreadIds,
    categories: Store.filters.categories,
    selectedFilter: Store.filters.selectedFilter,
    sound: Store.settings.sound,
    enterKey: Store.settings.enterKey,
    threadsOrdering: Store.settings.threadsOrdering,
    endRedirectUrl: Store.chat.endRedirectUrl,
  };
})

export default class Filters extends React.Component {
  mobilePanelClassName(panelClassName) {
    return panelClassName + ' ' + (this.props.mobilePanels[panelClassName]);
  }

  handleClick(panel) {
    this.props.dispatch(selectFilter(panel));

    if (panel !== 'search') {
      this.props.mobilePanelChange('threads');
    }
  }

  isSelected(element) {
    return ClassNames({
      'selected': (this.props.selectedFilter && this.props.selectedFilter == element),
      'brandedColor_border': (this.props.selectedFilter && this.props.selectedFilter == element)
    });
  }

  handleSetThreadOrdering(e) {
    const defaultOrderStatus = e.target.value;

    if (
      typeof defaultOrderStatus != undefined
      && (defaultOrderStatus == 'on' || defaultOrderStatus == 'off')
    ) {
      const orderBy = (defaultOrderStatus === 'off') ? 'createdAt' : 'touchedAt';

      this.props.dispatch(setThreadsOrering(orderBy));
    }
  }

  handleSetSoundMode(e) {
    const soundStatus = e.target.value;

    if (
      typeof soundStatus != undefined
      && (soundStatus == 'on' || soundStatus == 'off')
    ) {
      this.props.dispatch(toggleSound(soundStatus));
    }
  }

  handleSetEnterKeyMode(e) {
    const enterKeystatus = e.target.value;

    if (
      typeof enterKeystatus != undefined
      && (enterKeystatus == 'on' || enterKeystatus == 'off')
    ) {
      this.props.dispatch(toggleEnterKey(enterKeystatus));
    }
  }

  handleToggleFilters() {
    this.props.dispatch(toggleFiltersVisibility());
  }

  handdleQuitChat() {
    if (window.confirm(this.props.labels.ARE_YOU_SURE_LEAVE)) {
      window.location = this.props.endRedirectUrl;
      this.props.dispatch(closeUI());
      this.props.dispatch(notification(this.props.labels.CHAT_HAS_BEEN_CLOSED));
    }
  }

  render() {
    const orderedByActivityToggle = this.props.threadsOrdering;
    const soundToggle = this.props.sound;
    const enterToSendToggle = this.props.enterKey;

    return (
      <div className={this.mobilePanelClassName('filters')}>
        <div className='heading'>
          <h2>{this.props.labels.LIVE_CHAT}</h2>
          <button onClick={this.handleToggleFilters.bind(this)}><i className="pe-7s-menu"></i></button>
        </div>
        <div className='filters-list'>
          <ul className='clickable'>
            <li className={this.isSelected('all')} onClick={this.handleClick.bind(this, 'all')}>
              {this.props.labels.F_ALL_DISCUSSIONS} <span className='nb'>{this.props.threads.length}</span>
            </li>

            <li className={this.isSelected('followed')} onClick={this.handleClick.bind(this, 'followed')}>
              {this.props.labels.F_FOLLOWED} <span className='nb'>{this.props.followedThreadIds.length}</span>
            </li>
            <li className={this.isSelected('unread')} onClick={this.handleClick.bind(this, 'unread')}>
              {this.props.labels.F_UNREAD} <span className='nb'>{_.filter(this.props.threads, thread => {
                return (thread.read !== true)
              }).length}</span>
            </li>

            {
              (() => {
                if (this.props.luser.insider) {
                  // Insider - Unanswered filtering
                  return (
                    <li className={this.isSelected('unanswered')} onClick={this.handleClick.bind(this, 'unanswered')}>
                      {this.props.labels.F_UNANSWERED}
                      <i className="unanswered pe-7s-attention"></i>
                      <span className="nb">
                        {
                          _.filter(this.props.threads, thread => {
                            return (thread.unanswered === true || thread.unanswered === 'true')
                          }).length
                        }
                      </span>
                    </li>
                  );
                } else {
                  // Candidate - Your questions filtering
                  return (
                    <li className={this.isSelected('yours')} onClick={this.handleClick.bind(this, 'yours')}>
                      {this.props.labels.F_YOUR_QUESTIONS}
                      <span className='nb'>
                        {
                          _.filter(this.props.threads, thread => {
                            return (thread.author.id === this.props.luser.id)
                          }).length
                        }
                      </span>
                  </li>
                  );
                }
              })()
            }
          </ul>
          <hr/>
          {
          /*
          <ul className='search'>
            <li className={this.isSelected('search')}>
              <i className='pe-7s-search'></i>
              <input onClick={this.handleClick.bind(this, 'search')} type="text" placeholder={this.props.labels.F_SEARCH} />
            </li>
          </ul>
          <hr/>
          */
          }
          <h3>{this.props.labels.F_BY_TOPIC}</h3>
          <ul className="clickable">
            {
              this.props.categories.map(category => {
                return <li
                  key={'cat'+category.id}
                  className={this.isSelected('cat'+category.id)}
                  onClick={this.handleClick.bind(this, 'cat'+category.id)}>
                    {category.name}
                    <span className='nb'>{
                      _.filter(this.props.threads, ['categoryId', category.id]).length
                    }</span>
                </li>
              })
            }
          </ul>
          <hr/>

          <h3>{this.props.labels.SETTINGS}</h3>
          <ul className='settings'>
              <li className='hidden-mobile'><span>{this.props.labels.S_PRESS_ENTER_TO_SUBMIT}</span>
              <div className="switch">
                  <input type="radio"
                    className="switch-input"
                    name="enterKeymode"
                    value="on"
                    id="ek_on"
                    defaultChecked={ enterToSendToggle == 'on' ? true : false }
                    onChange={this.handleSetEnterKeyMode.bind(this)}
                  />
                  <label htmlFor="ek_on" className="switch-label switch-label-off">{this.props.labels.ON}</label>
                  <input type="radio"
                    className="switch-input"
                    name="enterKeymode"
                    value="off"
                    id="ek_off"
                    defaultChecked={ enterToSendToggle == 'off' ? true : false }
                    onChange={this.handleSetEnterKeyMode.bind(this)}
                  />
                  <label htmlFor="ek_off" className="switch-label switch-label-on">{this.props.labels.OFF}</label>
                  <span className="switch-selection brandedColor_bg"></span>
                </div>
                <div className='clear'></div>
            </li>
            <li><span>{this.props.labels.S_THREAD_ORDERING}</span>
              <div className="switch">
                  <input type="radio"
                    className="switch-input"
                    name="defaultthreadorder"
                    value="on" id="defaultthreadorder_on"
                    defaultChecked={ orderedByActivityToggle == 'touchedAt' ? true : false }
                    onChange={this.handleSetThreadOrdering.bind(this)}
                  />
                  <label htmlFor="defaultthreadorder_on" className="switch-label switch-label-off">{this.props.labels.ON}</label>
                  <input type="radio"
                    className="switch-input"
                    name="defaultthreadorder"
                    value="off"
                    defaultChecked={ orderedByActivityToggle == 'createdAt' ? true : false }
                    id="defaultthreadorder_off"
                    onChange={this.handleSetThreadOrdering.bind(this)}
                  />
                  <label htmlFor="defaultthreadorder_off" className="switch-label switch-label-on">{this.props.labels.OFF}</label>
                  <span className="switch-selection brandedColor_bg"></span>
                </div>
                <div className='clear'></div>
            </li>
            <li className='hidden-mobile'><span>{this.props.labels.S_SOUND}</span>
              <div className="switch">
                <input type="radio"
                  className="switch-input"
                  name="soundmode"
                  value="on"
                  id="s_on"
                  defaultChecked={ soundToggle == 'on' ? true : false }
                  onChange={this.handleSetSoundMode.bind(this)}
                />
                <label htmlFor="s_on" className="switch-label switch-label-off">{this.props.labels.ON}</label>
                <input type="radio"
                  className="switch-input"
                  name="soundmode"
                  value="off"
                  id="s_off"
                  defaultChecked={ soundToggle == 'off' ? true : false }
                  onChange={this.handleSetSoundMode.bind(this)}
                />
                <label htmlFor="s_off" className="switch-label switch-label-on">{this.props.labels.OFF}</label>
                <span className="switch-selection brandedColor_bg"></span>
              </div>
              <div className='clear'></div>
            </li>
          </ul>
          <ul className='action'>
            <li>
              <span className="leaveChatButton" onClick={this.handdleQuitChat.bind(this)}>
                <div className="icon-close brandedColor_bg">
                  <div className="pe-7s-power"></div>
                  <div className="text-btn-close">
                    {this.props.labels.ACTION_LEAVE_CHAT}
                  </div>
                </div>
              </span>
              <div className='clear'></div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/Filters.jsx